import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import URL from 'src/api/url'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { LandingPagePreview, TemplateSelect, Outline } from './components'
import { useParams } from 'react-router-dom'
import {
  getCollection,
  getCollectionLandingPageAction,
} from 'src/reducers/collection/action'
import { getCourseLandingPageAction } from 'src/reducers/course/action'
import Header from './components/header'
import TemplateRenderer from './data/template-renderer'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import HeaderTheme from './components/header-theme'
// Import updated LandingPageHeader
import { LandingPageHeader } from './components'
import { Helmet } from 'react-helmet'

const LandingPagePreviewMain = props => {
  const { classes } = props
  const course = useSelector(state => state.course.course)
  const pageUrl = window.location.pathname.split('/')[1]
  const [isLoading, setIsLoading] = useState(false)
  const [customHtmlContent, setCustomHtmlContent] = useState('')
  const [selectedTemplateId, setSelectedTemplateId] = useState(0)
  const [showTemplateSelect, setShowTemplateSelect] = useState(true) // State to control template visibility
  const [previewFont, setPreviewFont] = useState(null) // New state for font preview
  const { id, page, subPage } = useParams()
  const dispatch = useDispatch()
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  const collection = useSelector(state => state.collection.collection)
  const { value } = useCourseSettings('theme')
  // Then conditionally use the results
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings

  const showLayoutComponents =
    pageUrl === 'collection'
      ? true
      : (value === null ? 0 : value?.layout) === 0
      ? true
      : false
  useEffect(() => {
    if (pageUrl === 'collection') {
      dispatch(getCollection(id))
      dispatch(getCollectionLandingPageAction(id))
    } else if (pageUrl === 'mini-course') {
      dispatch(getCourseLandingPageAction(id))
    }
  }, [id])

  // Set the initial HTML content when landing page data is loaded
  useEffect(() => {
    if (landingPageData && landingPageData.html) {
      setCustomHtmlContent(landingPageData.html)
    }

    // Check if we should show the template select component
    if (landingPageData && landingPageData.initialized === true) {
      setShowTemplateSelect(false)
    } else {
      setShowTemplateSelect(true)
    }

    // Reset preview font when landingPageData changes
    setPreviewFont(null)
  }, [landingPageData])

  const themeSettingsStringified = course?.settingDtos?.find(
    setting => setting.key === 'theme',
  )
  const themeSettings = themeSettingsStringified
    ? JSON.parse(themeSettingsStringified?.value)
    : null

  const fontSize = themeSettings?.fontSize
  // Use previewFont if available, otherwise use the font from landingPageData
  const font = previewFont || landingPageData?.font

  const handleSetHtmlContent = html => {
    // Force a proper state change by creating a new string
    const newHtml = String(html || '')
    setCustomHtmlContent(newHtml)
  }

  // New function to handle template selection
  const handleTemplateSelection = templateId => {
    setSelectedTemplateId(templateId)
  }

  // New function to handle font selection for preview
  const handleFontSelection = font => {
    // Update the local state with the selected font
    setPreviewFont(font)
  }

  // New function to toggle template selector visibility
  const toggleTemplateSelect = () => {
    setShowTemplateSelect(prev => !prev)
  }

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={`https://fonts.googleapis.com/css?family=${font}:wght@100;200;300;400;500;600;700;800;900&display=swap`}
        />
      </Helmet>
      <div
        className={
          pageUrl === 'mini-course' ? classes.root : classes.collectionRoot
        }
      >
        <div className={classes.wrapper}>
          {showLayoutComponents === true && showTemplateSelect && (
            <TemplateSelect
              pageUrl={pageUrl}
              setHtmlContent={handleSetHtmlContent}
              setSelectedTemplateId={handleTemplateSelection}
              setSelectedFont={handleFontSelection}
            />
          )}
          <div className={classes.card}>
            {/* Pass the selectedTemplateId to LandingPageHeader */}
            <LandingPageHeader
              pageUrl={pageUrl}
              course={course}
              selectedTemplateId={selectedTemplateId}
            />

            {showLayoutComponents === true && <Header pageUrl={pageUrl} />}
            {showLayoutComponents === false && (
              <HeaderTheme pageUrl={pageUrl} />
            )}

            {landingPageData &&
            landingPageData.metadata !== null &&
            landingPageData.initialized !== true ? (
              <TemplateRenderer
                selectedTemplate={selectedTemplateId}
                fontFamily={font}
                fontSize={fontSize}
                theme={value === null ? 0 : value?.layout}
                courseData={landingPageData && landingPageData.metadata}
              />
            ) : (
              <LandingPagePreview
                key={customHtmlContent ? 'custom' : 'default'}
                pageUrl={pageUrl}
                fontFamily={font}
                fontSize={fontSize}
                theme={value === null ? 0 : value?.layout}
                customHtmlContent={customHtmlContent}
              />
            )}

            {showLayoutComponents === true && <Outline pageUrl={pageUrl} />}
          </div>
        </div>
      </div>
    </>
  )
}

export default withStyles(styles)(LandingPagePreviewMain)
